import { render, staticRenderFns } from "./documents.vue?vue&type=template&id=4ad994e4&scoped=true&"
import script from "./documents.vue?vue&type=script&lang=js&"
export * from "./documents.vue?vue&type=script&lang=js&"
import style0 from "./documents.vue?vue&type=style&index=0&id=4ad994e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad994e4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ad994e4')) {
      api.createRecord('4ad994e4', component.options)
    } else {
      api.reload('4ad994e4', component.options)
    }
    module.hot.accept("./documents.vue?vue&type=template&id=4ad994e4&scoped=true&", function () {
      api.rerender('4ad994e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/documents.vue"
export default component.exports